import { TProps } from './types/TProps';

export function InputUpload({
  accept = 'audio/x-m4a, audio/mpeg, audio/wav, video/x-msvideo, video/trm,.trm',
  onFiles,
  multiple,
}: TProps) {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) {
      onFiles([]);
      event.target.value = '';
      return;
    }
    onFiles(Array.from(event.target.files));
    event.target.value = '';
  };

  return (
    <div className="cursor-pointer rounded-[5px] border border-dashed border-[var(--color-tint)]">
      <label className="InputUpload-label block w-full cursor-pointer overflow-hidden relative p-[15px] text-center align-middle">
        <div>
          <span className="InputUpload-label-span block text-center font-semibold text-xs leading-[18px] text-[var(--color-text-subtle)]">
            Drag and drop or click{' '}
            <span className="InputUpload-here-span underline text-[var(--color-text-muted)]">here</span> to upload your
            files
          </span>
          <input
            className="InputUpload-input invisible absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 overflow-hidden"
            type="file"
            multiple={multiple}
            accept={accept}
            onChange={onChange}
          />
        </div>
      </label>
    </div>
  );
}
